import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";

const ImageCarousel = ({ images = [], height = 200, alt = "" }) => {
  const [index, setIndex] = useState(0);
  const list = (images || []).filter(Boolean);

  if (!list.length) return null;

  const goPrev = () => setIndex((i) => (i - 1 + list.length) % list.length);
  const goNext = () => setIndex((i) => (i + 1) % list.length);

  return (
    <Box sx={{ position: "relative", borderRadius: 1, overflow: "hidden", border: "1px solid #ddd" }}>
      <img
        src={list[index]}
        alt={alt}
        style={{ width: "100%", height, objectFit: "cover", display: "block", backgroundColor: "#f7f7f7" }}
      />
      {list.length > 1 && (
        <>
          <IconButton
            size="small"
            onClick={goPrev}
            sx={{
              position: "absolute",
              top: "50%",
              left: 4,
              transform: "translateY(-50%)",
              bgcolor: "rgba(255,255,255,0.85)",
              "&:hover": { bgcolor: "rgba(255,255,255,0.95)" },
            }}
          >
            <ArrowBackIosNew fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={goNext}
            sx={{
              position: "absolute",
              top: "50%",
              right: 4,
              transform: "translateY(-50%)",
              bgcolor: "rgba(255,255,255,0.85)",
              "&:hover": { bgcolor: "rgba(255,255,255,0.95)" },
            }}
          >
            <ArrowForwardIos fontSize="small" />
          </IconButton>
          <Box sx={{ position: "absolute", bottom: 8, left: 0, right: 0, display: "flex", justifyContent: "center", gap: 0.75 }}>
            {list.map((_, i) => (
              <Box
                key={i}
                onClick={() => setIndex(i)}
                sx={{
                  width: i === index ? 8 : 6,
                  height: i === index ? 8 : 6,
                  borderRadius: "50%",
                  bgcolor: i === index ? "#fff" : "rgba(255,255,255,0.55)",
                  cursor: "pointer",
                  boxShadow: "0 0 2px rgba(0,0,0,0.4)",
                }}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default ImageCarousel;
